import { Component } from '@angular/core';

import { Institution } from '../modules/datamodel/institution';
import { StateService } from '../services/state/state.service';

@Component({templateUrl: 'providers.component.html'})
export class ProvidersComponent {

    public selectedInstitution : Institution
    public activated : number = 0;
    public pending : number = 0;
    public total : number = 0;

    constructor(private state : StateService) {
        state
            .selectedInstitution
            .subscribe(si => {
                this.selectedInstitution = si;
                this.activated = this.pending = this.total = 0;
                if (this.selectedInstitution && this.selectedInstitution.providers) {
                    this.activated = this
                        .selectedInstitution
                        .providers
                        //.filter(p => p.user && p.user.ref)
                        .length;
                    this.total = this.selectedInstitution.providers.length;
                    this.pending = this.total - this.activated;

                    this
                        .selectedInstitution
                        .providers
                        .forEach(async p => {
                            /*if (p.user) {
                                p.user.data = (await p.user.ref.get()).data();
                            }*/
                        })
                }
            });
    }

}


// WEBPACK FOOTER //
// ./src/app/providers/providers.component.ts